import { Component, Input, ViewChild } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { TimeOffRequestBlackoutPeriod } from '@models/time-off-v3/time-off-request-blackout-period.model';
import moment, { Moment } from 'moment';
import { DateRange } from '@angular/material/datepicker';
import { InlineDatePickerComponent } from '@app/components';

@Component({
    selector: 'app-blackout-period-form',
    templateUrl: './blackout-period.template.html',
})
export class BlackoutPeriodForm extends BaseForm {
    @ViewChild('calendar') calendar: InlineDatePickerComponent;
    @Input() timeOffRequestBlackoutPeriod: TimeOffRequestBlackoutPeriod = new TimeOffRequestBlackoutPeriod();
    @Input() year: number;

    isUpdate = false;

    beforeShow(): void {
        if (this.isUpdate) {
            this.goToDateInView();
            return;
        }

        this.timeOffRequestBlackoutPeriod = new TimeOffRequestBlackoutPeriod();
        this.goToDateInView(moment(`${this.year}-01-01`));
    }

    setDateRange(dateRange: DateRange<Date>): void {
        this.timeOffRequestBlackoutPeriod.startDate = dateRange.start;
        this.timeOffRequestBlackoutPeriod.endDate = dateRange.end;
    }

    goToDateInView(date?: Moment): void {
        this.calendar.goToDate(date ?? moment(this.timeOffRequestBlackoutPeriod.startDate), 'month');
    }
}
